var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isMobile || _vm.isVisible)?_vm._t("default"):_vm._e(),(_vm.isMobile && !_vm.isVisible)?_c('div',{staticClass:"collapse-mobile__more"},[_c('span',{on:{"click":_vm.show}},[_vm._v("Читать еще")])]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }